import { useContext } from "react";
import { ContextAuth } from "../../contexts";

export const useHooksAuth = () => useContext(ContextAuth);
